export default __webpack_public_path__ + "static/media/Edit.cd776dca.svg";